import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatButtonModule} from '@angular/material/button';

import { CompassDetailComponent } from './compass-detail.component';
import { AuthGuard } from '../guards/auth.guard';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AlertDefinitionsModule } from './alerts/alerts.module';
import { EditAssignmentDialogModule } from '../components/edit-assignment-dialog/edit-assignment-dialog.module';
import { CompassSummaryChartModule } from '../components/compass-summary-chart/compass-summary-chart.module';


@NgModule({
  imports: [
    AlertDefinitionsModule,
    CommonModule,
    CompassSummaryChartModule,
    EditAssignmentDialogModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSortModule,
    MatTooltipModule,
    RouterModule.forChild([
      {
        path: 'compass-detail/:bulkSubscriptionId',
        canActivate: [AuthGuard],
        component: CompassDetailComponent,
        children: []
      }
    ])
  ],
  declarations: [
    CompassDetailComponent
  ],
  exports: [
    CompassDetailComponent
  ],
  providers: [

  ]
})
export class CompassDetailModule { }
